import xhr from 'xhr';
import assign from 'object-assign';

import ApplicationDispatcher from '../../dispatcher/ApplicationDispatcher.js';

import ApiUtils from '../../utils/ApiUtils.js';
import MetadataConstants from './MetadataConstants.js';

export default {
    fetchedAnalytics: function (response) {
        ApplicationDispatcher.handleServerAction({
            actionType: MetadataConstants.ANALYTICS_FETCHED,
            data: response
        });
    },

    // events in date range
    requestSchedules: function (opts) {
        ApplicationDispatcher.handleViewAction({
            actionType: MetadataConstants.REQUEST_SCHEDULES,
            data: assign({}, opts, { resultMax: 1000 })
        });
    },

    fetchedSchedules: function (data) {
        ApplicationDispatcher.handleServerAction({
            actionType: MetadataConstants.FETCHED_SCHEDULES,
            data: data
        });
    },

    fetchedAssets: function (response) {
        ApplicationDispatcher.handleServerAction({
            actionType: MetadataConstants.ASSETS_FETCHED,
            data: response
        });
    },

    fetchedMiscellaneousAssets: function (response) {
        ApplicationDispatcher.handleServerAction({
            actionType: MetadataConstants.MISC_ASSETS_FETCHED,
            data: response
        });
    },

    fetchedCategories: function (response) {
        ApplicationDispatcher.handleServerAction({
            actionType: MetadataConstants.CATEGORIES_FETCHED,
            data: response
        });
    },

    fetchedKeywords: function (response) {
        ApplicationDispatcher.handleServerAction({
            actionType: MetadataConstants.KEYWORDS_FETCHED,
            data: response
        });
    },

    fetchedEncoders: function (response) {
        ApplicationDispatcher.handleServerAction({
            actionType: MetadataConstants.ENCODERS_FETCHED,
            data: response
        });
    },

    fetchedTechnicians: function (response) {
        ApplicationDispatcher.handleServerAction({
            actionType: MetadataConstants.TECHNICIANS_FETCHED,
            data: response
        });
    },

    fetchedLocations: function (response) {
        ApplicationDispatcher.handleServerAction({
            actionType: MetadataConstants.LOCATIONS_FETCHED,
            data: response
        });
    },

    refetch: function () {
        ApplicationDispatcher.handleServerAction({
            actionType: MetadataConstants.REFETCH
        });
    }
};
